import type { DashboardViewConfigurationResponse } from "@rumbledirect/types";
import { axiosInstance } from "../client";

export const fetchDashboardViewConfiguration =
  async (): Promise<DashboardViewConfigurationResponse | null> => {
    return await axiosInstance
      .get("/admin/current-user/dashboard")
      .then((response) => response.data as DashboardViewConfigurationResponse);
  };
